import { render, staticRenderFns } from "./kundeitem2.vue?vue&type=template&id=20e61b92&scoped=true&"
import script from "./kundeitem2.vue?vue&type=script&lang=js&"
export * from "./kundeitem2.vue?vue&type=script&lang=js&"
import style0 from "./kundeitem2.vue?vue&type=style&index=0&id=20e61b92&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20e61b92",
  null
  
)

export default component.exports